import client from './client';
import { AuditResult } from '../types';

export const auditApi = {
  run: () => client.post<AuditResult>('/audit/run'),

  getLatest: () => client.get<AuditResult>('/audit/latest'),

  history: () => client.get<AuditResult[]>('/audit/history'),
};
